import * as React from 'react';
import { getBasePath } from '../../utils/browser';

interface SettingTabPanelStyleProps {
  readonly style?: React.CSSProperties;
}

interface SettingTabPanelListRowImageTitleProps {
  readonly imgName: string;
  readonly containerStyle?: React.CSSProperties;
  readonly imageStyle?: React.CSSProperties;
}

const columnStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

const rowStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: '4px',
  paddingBottom: '4px',
};

const titleImageStyle: React.CSSProperties = {
  alignItems: 'center',
  width: 123,
  height: 'auto',
  flexShrink: 0,
};

const titleContainerStyle: React.CSSProperties = {
  display: 'flex',
  width: 123,
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
};

const titleStyle: React.CSSProperties = {
  flexShrink: 0,
  width: '6em',
  textAlign: 'right',
};

export const SettingTabPanelList: React.SFC<SettingTabPanelStyleProps> = React.memo((props) => {
  return (
    <div style={{ ...columnStyle, ...props.style }}>{props.children}</div>
  );
});

export const SettingTabPanelListRow: React.SFC<SettingTabPanelStyleProps> = React.memo((props) => {
  return (
    <div style={{ ...rowStyle, ...props.style }}>{props.children}</div>
  );
});

export const SettingTabPanelListRowImageTitle:
  React.SFC<SettingTabPanelListRowImageTitleProps> = React.memo((props) => {
    const { imgName, containerStyle, imageStyle } = props;
    const baseDir = getBasePath();
    const imgSrc = `${baseDir}/images/setting-popup/text/${imgName}.png`;
    return (
      <div style={{ ...titleContainerStyle, ...containerStyle }}>
        <img src={imgSrc} style={{ ...titleImageStyle, ...imageStyle }} />
      </div>
    );
  });

export const SettingTabPanelListRowTitle: React.SFC = React.memo((props) => {
  return (
    <div style={titleStyle}>{props.children}</div>
  );
});
